<template>
  <form v-on:submit="validateAndSendForm">
    <slot></slot>
    <div></div>
  </form>
</template>

<script>
export default {
  name: 'dx-form',
  props: {
    onSubmit: Function,
  },
  data() {
    return {
      isLoading: false,
      validations: [],
    };
  },
  watch: {
    isLoading(newValue) {
      if (newValue) {
        document.body.classList.add('loading');
      } else {
        document.body.classList.remove('loading');
      }
    },
  },
  methods: {
    async validateAndSendForm(e) {
      e.preventDefault();
      if (this.isLoading === true) {
        return;
      }

      this.isLoading = true;

      const formAreValid = await this.validateForm();

      if (formAreValid) {
        await this.onSubmit();
      }
      this.isLoading = false;
    },
    async validateForm() {
      // validations are added by children components. Ex: dx-input
      return (await Promise.all(this.validations.map((validation) => validation())))
        .every((v) => v === true);
    },
  },
};
</script>
